<template>
    <van-popup
        v-if="contactAddPopupShow"
        :value="contactAddPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container customer_members_list" v-loading="loading">
            <div class="returnNavBar">
                <div class="returnNavBarLeft" @click="handleClickClose">
                    <van-icon name="arrow-left" />
                    <span class="normal_title">返回</span>
                </div>
            </div>
            <div class="mobile_container">
                <CustomFormMobile
                    ref="contact_add_form"
                    :field_list="formInfoList"
                    :is_form_module="true"
                    @submit-form="submitFormData"
                    v-if="dataLoaded"
                />
            </div>
            <div class="add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
        </div>
    </van-popup>
</template>
<script>
import { getFormFields, ContactAdd } from "@/api";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "ContactAdd",
    props: {
        contactAddPopupShow: {
            type: Boolean,
            default: false,
        },
        customer_id: {
            type: Number,
            default: 0,
        },
    },
    components: { CustomFormMobile },
    data() {
        return {
            loading: false,
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
        };
    },
    created() {
        this._getFromFields();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:contactAddPopupShow", false);
        },
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customer_contacts",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    this.loading = false;
                    this.dataLoaded = true;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.contact_add_form.handleClickPublish();
        },
        // 提交
        submitFormData(customForm) {
            if (customForm) {
                this.loading = true;
                this.btnDisabled = true;
                ContactAdd({ customer_id: this.customer_id, ...customForm }).then((res) => {
                    this.loading = false;
                    this.btnDisabled = false;
                    this.$toast({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.$emit("update:contactAddPopupShow", false);
                            this.$emit("contactAddSuccess");
                        },
                    });
                });
            }
        },
    },
};
</script>
